import { EnvironmentStage } from "@/types/awsm";

export const path = "/api/dirs/typeahead-suggestions/items";
export const default_tags = new Map([
  ["order_by", "SortOrderValue"],
  ["sort_ascending", "true"],
  ["limit", "250"],
]);
export const env = "prod" as EnvironmentStage;

// TODO remove once auth DNS migration is completed
export const AUTH_SERVICE_ROOT =
  process.env.STAGE === EnvironmentStage.PROD
    ? "auth.aws.amazon.com"
    : `${process.env.STAGE}.auth-builderprofile.aws.dev`;
export const VALIDATE_SESSION_API =
  process.env.NEXT_VALIDATE_SESSION_API ||
  `https://${AUTH_SERVICE_ROOT}/validate-session`;
// TODO: Replace with Horizon value once we accept that header in Auth.
export const OUTBOUND_AUTH_REQUEST_ORIGIN_SOURCE_HEADER =
  "webinar-registration-portal-internal-request-custom-header";
export const SESSION_COOKIE_KEY = "awsm-session";
// for federate
export const VALID_SESSION_COOKIE_KEY = "awsm-valid-session";
export const AEA_PLUGIN_PRESENT_COOKIE_KEY = "aea_plugin_present";
